(function () {
  'use strict';
  // The theme supplies its existing DiscountHero boundary. This worker owns no
  // transport or coupon storage and cannot introduce a second coupon writer.
  window.athCreatePromotionReconciler = function (deps) {
    var requested = 0, running = null, removal = null, failure = null;
    function same(a,b) { return (a || '').toUpperCase() === (b || '').toUpperCase(); }
    function signature(input) { return JSON.stringify(input); }
    function revision() { return deps.revision ? deps.revision() : 0; }
    function key(input,decision) { return signature(input)+'|'+decision.code+'|'+decision.percentage+'|'+revision(); }
    function managed(value) { return deps.isManagedCode ? deps.isManagedCode(value) : /^(BLACKFRIDAYDEALS|BUYMORE[2-5](?:EBF)?)$/i.test(value || ''); }
    async function drain() {
      var processed;
      do {
        processed = requested;
        await deps.ready();
        await deps.waitForIdle();
        if (removal) {
          var choice=removal;removal=null;failure=null;
          var removalBusy=false;
          try {
            try {await deps.readCart();} catch (e) { /* The clicked tag establishes the selected code too. */ }
            var selected=deps.readCode() || choice.code;
            if (selected && managed(selected)) {
              deps.setBusy(true);removalBusy=true;await deps.remove(selected);
            }
            choice.resolve();
          } catch (removalError) {choice.reject(removalError);}
          finally {if(removalBusy) deps.setBusy(false);await deps.onSettled();}
          continue;
        }
        if (deps.isBlocked()) continue;
        var input = await deps.readCart();
        if (processed !== requested || deps.isBlocked(input)) continue;
        var previous = deps.readCode();
        var decision = deps.resolve(Object.assign({},input,{currentCode:previous}));
        if (decision.mode === 'standard' || (decision.mode === 'suspended' && (previous || !decision.code)) || same(previous,decision.code) ||
            (decision.mode === 'pending' && previous) || !input.quantity || (failure && failure.key === key(input,decision) && same(previous,failure.confirmed))) continue;
        // Revalidate immediately before the first mutation. A stale caller's
        // quantity never commits merely because it was queued first.
        input = await deps.readCart();
        if (processed !== requested || deps.isBlocked(input) || !same(previous,deps.readCode())) continue;
        decision = deps.resolve(Object.assign({},input,{currentCode:previous}));
        if (decision.mode === 'standard' || (decision.mode === 'suspended' && (previous || !decision.code)) || same(previous,decision.code) || !input.quantity) continue;
        deps.setBusy(true);
        var removed = false, attempt=key(input,decision), attemptInput=signature(input), attemptRevision=revision();
        try {
          if (previous) { await deps.remove(previous); removed = true; }
          input = await deps.readCart();
          if (deps.isBlocked(input) || removal) continue;
          decision = deps.resolve(Object.assign({},input,{currentCode:deps.readCode()}));
          if (decision.mode === 'standard' || (decision.mode === 'suspended' && (removed || !decision.code)) || !input.quantity) {
            if (removed && !deps.readCode() && deps.canRestore(previous,input)) await deps.apply(previous);
            continue;
          }
          attempt=key(input,decision);attemptInput=signature(input);attemptRevision=revision();
          if (decision.code) await deps.apply(decision.code);
          failure=null;
        } catch (e) {
          // Never restore over a newer customer-selected code. A prior tier must
          // still qualify in the newest readable cart before compensation.
          try {
            input = await deps.readCart();
            if (removed && !removal && !deps.isBlocked(input) && !deps.readCode() && deps.canRestore(previous,input)) await deps.apply(previous);
          } catch (restoreError) { /* Render the app's confirmed state below. */ }
          failure={key:attempt,input:attemptInput,revision:attemptRevision,confirmed:deps.readCode(),target:decision.code};
        } finally {
          deps.setBusy(false);
          await deps.onSettled();
        }
      } while (processed !== requested);
    }
    function schedule() {
      requested++;
      if (!running) running=drain().catch(function(error){if(removal){removal.reject(error);removal=null;} /* Failed reads cannot authorize a coupon change. */ }).finally(function(){running=null;});
      return running;
    }
    function failedFor(input) {return !!(failure && failure.input === signature(input) && failure.revision === revision() && same(failure.confirmed,deps.readCode()));}
    return {
      request:schedule,
      remove:function(code) {
        if (removal) return removal.promise;
        var choice={code:code};
        choice.promise=new Promise(function(resolve,reject){choice.resolve=resolve;choice.reject=reject;});
        removal=choice;schedule();return choice.promise;
      },
      failedFor:failedFor,
      failedCodeFor:function(input){return failedFor(input) ? failure.target : null;}
    };
  };
})();
